import React from "react";
import {CalendarOutlined} from "@ant-design/icons";
import {Text, TextAs, TextSizes, Tooltip} from "@clockout-dev/design-elements";
import SectionCard from "../../common/sectionCard/SectionCard";
import styles from "../styles/results.module.scss";

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

function formatPeriodEnd(chip) {
    if (chip.date) return `${MONTHS[chip.date.getUTCMonth()]} ${chip.date.getUTCDate()}`;
    return String(chip.periodEnd);
}

/**
 * Pay-period contiguity visualization for the full manual flow: one chip per
 * period end, solid links between contiguous periods, dashed "gap" markers
 * where the cadence breaks, excluded periods grayed out with their reason in
 * a tooltip, and qualifying periods highlighted. Data comes pre-shaped from
 * `buildContiguityModel`.
 *
 * @param {Object} props
 * @param {Object} props.model — output of `buildContiguityModel`
 */
function ContiguityStrip({model}) {
    if (!model?.hasData) return null;
    const {chips, contiguousCount, requiredCount} = model;

    return (
        <SectionCard icon={<CalendarOutlined />} title="Paystub Contiguity">
            {contiguousCount !== null && requiredCount !== null ? (
                <Text as={TextAs.P} size={TextSizes.EXTRA_SMALL} className={contiguousCount >= requiredCount ? styles.contiguitySummaryOk : styles.contiguitySummaryShort}>
                    {contiguousCount} contiguous of {requiredCount} required
                </Text>
            ) : null}

            <div className={styles.contiguityStrip}>
                {chips.map((chip, index) => (
                    <React.Fragment key={chip.key}>
                        <Tooltip title={chip.excluded ? `Excluded: ${chip.excludedReason}` : chip.qualifying ? "Part of the qualifying run" : `Period ending ${chip.periodEnd}`}>
                            <span className={`${styles.periodChip} ${chip.excluded ? styles.periodChipExcluded : ""} ${chip.qualifying ? styles.periodChipQualifying : ""}`}>
                                {formatPeriodEnd(chip)}
                            </span>
                        </Tooltip>
                        {index < chips.length - 1 ? (
                            chip.gapAfter ? (
                                <span className={styles.periodGap}>
                                    <Text as={TextAs.SPAN} size={TextSizes.EXTRA_SMALL} className={styles.periodGapLabel}>
                                        gap
                                    </Text>
                                </span>
                            ) : (
                                <span className={styles.periodLink} />
                            )
                        ) : null}
                    </React.Fragment>
                ))}
            </div>
        </SectionCard>
    );
}

export default ContiguityStrip;
